import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import Home from "./pages/Home";
import TermsCondition from "./pages/TermsCondition";
import Cart from "./pages/Cart";
import TermsOfUse from "./pages/TermsOfUse";
import TripHailingProcedure from "./pages/TripHailingProcedure";
import FAQs from "./pages/FAQs";
import PackageSendingProcedures from "./pages/PackageSendingProcedures";
import ShoppingOnlineProcedures from "./pages/ShoppingOnlineProcedures";
import ReturnRefundPolicy from "./pages/ReturnRefundPolicy";
import CourierDriverRules from "./pages/CourierDriverRules";
import DataPrivacyPolicy from "./pages/DataPrivacyPolicy";
import CustomerParcelPickupDrop from "./pages/CustomerParcelPickupDrop";
import OrderHistory from "./pages/OrderHistory";
import CheckOut from "./pages/CheckOut";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/TermsCondition" element={<TermsCondition />} />
        <Route path="/Cart" element={<Cart />} />
        <Route path="/TermsOfUse" element={<TermsOfUse />} />
        <Route path="/TripHailingProcedure" element={<TripHailingProcedure />} />
        <Route path="/FAQs" element={<FAQs />} />
        <Route path="/PackageSendingProcedures" element={<PackageSendingProcedures />} />
        <Route path="/ShoppingOnlineProcedures" element={<ShoppingOnlineProcedures />} />
        <Route path="/ReturnRefundPolicy" element={<ReturnRefundPolicy />} />
        <Route path="/CourierDriverRules" element={<CourierDriverRules />} />
        <Route path="/DataPrivacyPolicy" element={<DataPrivacyPolicy />} />
        <Route path="/CustomerParcelPickupDrop" element={<CustomerParcelPickupDrop />} />
        <Route path="/OrderHistory" element={<OrderHistory />} />
        <Route path="/CheckOut" element={<CheckOut />} />

      </Routes>
    </Router>
  );
}

export default App;
